import * as core from '../../../../../../../core'

import { query } from './outcomes-sunburst.query'

export const RESOURCE = {
  payload: {
    alias: 'summit.outcomes-sunburst',
    description:
      "Sunburst chart used to explore the institution's goals, objectives, and other outcomes",
    name: 'Summit - Outcomes Sunburst',
    query,
    variables: [],
  },
  type: core.quiver.Resource.Type.MosaicWidget,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.MosaicWidget>
